module.exports = __webpack_public_path__ + "static/img/njddBg.c306480e.png";